// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"374532a8","239":"b67fbdf4","701":"5cbd9eb2","732":"5420f41a","771":"7c27dd8b","977":"1bb12ded"}[chunkId] + ".chunk.js";
};